export default (that) => [
  {
    text: that.$l('btn_view_sku_details') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
    allow: 'SQ',
  },
  {
    text: that.$l('btn_edit_sku_product') || '编辑产品',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'SM',
    disabled: ({ evgSkuStatus, applicationStatus }) => {
      return (
        that.disabled ||
        ['D'].includes(evgSkuStatus) ||
        (!!applicationStatus && ['O', 'P'].includes(applicationStatus))
      )
    },
  },
  {
    text: that.$l('btn_delete_sku_product') || '删除产品',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'SD',
    disabled: ({ evgSkuStatus, applicationStatus }) => {
      return (
        evgSkuStatus != 'Q' ||
        (!!applicationStatus && ['P', 'A'].includes(applicationStatus)) ||
        that.disabled
      )
    },
  },
  {
    text: that.$l('btn_copy_sku_sku') || '复制产品',
    icon: 'el-icon-document-copy',
    menuType: 'copy',
    allow: 'SE',
    divided: true,
    disabled: ({ evgSkuStatus }) => {
      return evgSkuStatus == 'D' || that.disabled
    },
  },
  {
    text: that.$l('btn_copy_skuToSpu') || '复制到其他SPU',
    icon: 'el-icon-copy-document',
    menuType: 'copy-to-spu',
    allow: 'SB',
    disabled: ({ evgSkuStatus }) => {
      return evgSkuStatus == 'D' || that.disabled
    },
  },
  {
    text: that.$l('btn_submission_information_review') || '提交信息审核',
    icon: 'el-icon-check',
    menuType: 'informationReview',
    allow: 'SS',
    divided: true,
    disabled: ({ evgSkuStatus, applicationStatus }) => {
      return (
        evgSkuStatus != 'Q' ||
        (!!applicationStatus && ['A', 'P'].includes(applicationStatus)) ||
        that.disabled
      )
    },
  },
  {
    text: that.$l('btn_submission_for_order_placement_sku') || '提交转可下单',
    icon: 'el-icon-check',
    menuType: 'purchasableApply',
    allow: 'SG',
    disabled: ({ evgSkuStatus, applicationStatus }) => {
      return (
        evgSkuStatus != 'C' ||
        (!!applicationStatus && ['O'].includes(applicationStatus)) ||
        that.disabled
      )
    },
  },
]
